var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    viewBox: "0 0 4 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95612 3.64592C3.92715 3.71545 3.88469 3.77857 3.83121 3.83161L0.978099 6.68472C0.870649 6.79217 0.724915 6.85254 0.572957 6.85254C0.421 6.85254 0.275266 6.79217 0.167815 6.68472C0.060365 6.57727 0 6.43154 0 6.27958C0 6.12762 0.060365 5.98189 0.167815 5.87444L2.62149 3.42647L0.167815 0.9785C0.060365 0.87105 0 0.725317 0 0.573359C0 0.421401 0.060365 0.275668 0.167815 0.168218C0.275266 0.0607672 0.421 0.000401974 0.572957 0.000401974C0.724915 0.000401974 0.870649 0.0607672 0.978099 0.168218L3.83121 3.02133C3.88469 3.07438 3.92715 3.13749 3.95612 3.20702C3.98509 3.27656 4 3.35114 4 3.42647C4 3.5018 3.98509 3.57638 3.95612 3.64592Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarNextArrow);
export default __webpack_public_path__ + "static/media/calendar-next-arrow.f6487feb986af3844d094d4a147c1bbd.svg";
export { ForwardRef as ReactComponent };